import { render, staticRenderFns } from "./MoleculeEditionMapChartBoard.vue?vue&type=template&id=0cf059e7&"
import script from "./MoleculeEditionMapChartBoard.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionMapChartBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports